export enum PropertyDataType {
  STRING,
  NUMBER
}

export class SortHelper {
  static sortArrayByPropertyValue(arrayToSort: any[], propertyName: string, propertyDataType: PropertyDataType) {
    switch (propertyDataType) {
      case PropertyDataType.STRING:
        arrayToSort.sort((a, b) => (a[propertyName]?.toLowerCase() > b[propertyName]?.toLowerCase()) ? 1 : -1);
        break;
      case PropertyDataType.NUMBER:
        arrayToSort.sort((a, b) => (Number(a[propertyName]) > Number(b[propertyName])) ? 1 : -1);
        break;
    }
  }

  static sortDescArrayByPropertyValue(arrayToSort: any[], propertyName: string, propertyDataType: PropertyDataType) {
    switch (propertyDataType) {
      case PropertyDataType.STRING:
        arrayToSort.sort((a, b) => (b[propertyName]?.toLowerCase() > a[propertyName]?.toLowerCase()) ? 1 : -1);
        break;
      case PropertyDataType.NUMBER:
        arrayToSort.sort((a, b) => (Number(b[propertyName]) > Number(a[propertyName])) ? 1 : -1);
        break;
    }
  }

  static sortArrayByMultiplePropertyValues(arrayToSort: any[], propertyNames: string[], propertyDataTypes: PropertyDataType[]) {
    const sorts: string[] = [];
    let i = 0;
    propertyNames.forEach(propertyName => {
      const propertyDataType = propertyDataTypes[i];
      switch (propertyDataType) {
        case PropertyDataType.STRING:
          sorts.push(`(a[${propertyName}]?.toLowerCase() > b[${propertyName}]?.toLowerCase()) ? 1 : -1`);
          break;
      }
      i++;
    });
    const sortsToEval = sorts.join(' || ');
    arrayToSort.sort((a, b) => eval(sortsToEval));
  }

  static sortArrayByDate(arrayToSort: any[], propertyName: string, sortOrder?: undefined | string) {
    if (!sortOrder || sortOrder.toLowerCase() === 'asc') {
      arrayToSort = arrayToSort.sort((a, b) => <any>new Date(a[propertyName]) - <any>new Date(b[propertyName]));
    } else if(sortOrder.toLowerCase() === 'desc'){
      arrayToSort = arrayToSort.sort((a, b) => <any>new Date(b[propertyName]) - <any>new Date(a[propertyName]));
    }
  }
}
